var map = {
	"./AAVE.svg": 460,
	"./ADA.svg": 461,
	"./ADX.svg": 462,
	"./ANY.png": 463,
	"./ATOM.png": 464,
	"./AVAX.png": 465,
	"./BAKE.png": 466,
	"./BANANA.svg": 467,
	"./BCH.svg": 468,
	"./BDO.png": 469,
	"./BETH.png": 470,
	"./BHC.png": 471,
	"./BIFI.png": 472,
	"./BNB.png": 473,
	"./BONE.png": 474,
	"./BONEswap.png": 475,
	"./BOO.png": 476,
	"./BORING.png": 477,
	"./BSCPAD.png": 478,
	"./BTCB.svg": 479,
	"./BTD.png": 480,
	"./BTS.png": 481,
	"./BUNNY.png": 482,
	"./BURGER.png": 483,
	"./BUSD.svg": 484,
	"./CAKE.svg": 485,
	"./CARROT.png": 486,
	"./CHESS.svg": 487,
	"./CTK.png": 488,
	"./DAI.png": 489,
	"./DAI.svg": 490,
	"./DFYN.png": 491,
	"./DG.png": 492,
	"./DOT.png": 493,
	"./DRUGS.png": 494,
	"./DVI.svg": 495,
	"./ETH.svg": 496,
	"./EZ.png": 497,
	"./FANTOM.png": 498,
	"./FFF.png": 499,
	"./FIL.svg": 500,
	"./FISH.svg": 501,
	"./FORM.svg": 502,
	"./FTM.png": 503,
	"./HAI.png": 504,
	"./HARD.png": 505,
	"./HBTC.png": 506,
	"./HECO.png": 507,
	"./HPS.png": 508,
	"./HT.png": 509,
	"./HTB.svg": 510,
	"./HUSD.png": 511,
	"./ICA.svg": 512,
	"./ICE.png": 513,
	"./INCH.png": 514,
	"./INJ.png": 515,
	"./JETS.png": 516,
	"./JULD.png": 517,
	"./KEBAB.png": 518,
	"./KROWN.png": 519,
	"./LINK.png": 520,
	"./LTC.svg": 521,
	"./MAI.png": 522,
	"./MARSH.png": 523,
	"./MASK.svg": 524,
	"./MATIC.svg": 525,
	"./MDX.png": 526,
	"./MERL.svg": 527,
	"./MIM.png": 528,
	"./MSC.png": 529,
	"./MSS.png": 530,
	"./NEXO.png": 531,
	"./NUTS.png": 532,
	"./NYA.png": 533,
	"./NYAC.png": 534,
	"./NYAS.png": 535,
	"./O3.png": 536,
	"./ONE.svg": 537,
	"./OOE.svg": 538,
	"./ORBS.svg": 539,
	"./PBNB.png": 540,
	"./PMP.svg": 541,
	"./PNG.svg": 542,
	"./POLYGON.png": 543,
	"./PUP.png": 544,
	"./PolyDoge.png": 545,
	"./QI.png": 546,
	"./QUICK.png": 547,
	"./RABBIT.svg": 548,
	"./RAMP.png": 549,
	"./ROUTE.png": 550,
	"./SBDO.png": 551,
	"./SFP.png": 552,
	"./SMART.png": 553,
	"./SNX.png": 554,
	"./SOAK.png": 555,
	"./SPIRIT.png": 556,
	"./STEEL.png": 557,
	"./SUSHI.png": 558,
	"./SWAMP.svg": 559,
	"./SX.png": 560,
	"./SXP.svg": 561,
	"./TEL.png": 562,
	"./TENFI.png": 563,
	"./TITAN.svg": 564,
	"./TYPH.png": 565,
	"./UFT.png": 566,
	"./UNI.png": 567,
	"./USDC.svg": 568,
	"./USDT.svg": 569,
	"./WATCH.png": 570,
	"./WAULTx.svg": 571,
	"./WBNB.svg": 572,
	"./WBTC.svg": 573,
	"./WEX.svg": 574,
	"./WOO.svg": 575,
	"./WOOFY.png": 576,
	"./XRP.svg": 577,
	"./XTZ.png": 578,
	"./XVS.png": 579,
	"./YELD.png": 580,
	"./YFI.png": 581,
	"./ZBTC.svg": 582,
	"./ZETH.svg": 583,
	"./cakeHARD.png": 584,
	"./cakeROOBEE.png": 585,
	"./cakeSTAX.png": 586,
	"./cakeTWT.png": 587,
	"./cakebROOBEE.png": 588,
	"./fUSDT.png": 589,
	"./ibBTC.svg": 590,
	"./pWINGS.png": 591,
	"./polyBUNNY.png": 592,
	"./rUSD.svg": 593,
	"./renBTC.png": 594,
	"./sALPACA.svg": 595
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1148;